import { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import dashLogo from '../../images/HUGHES-DIGITAL-SIGNAGE_BLUE.png';

interface ForgotPasswordProps {
  actionUrl: string;
  error?: string;
}

export function MssForgotPassword({ actionUrl, error }: ForgotPasswordProps) {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const csrfToken = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? '';

  const handleSubmit = () => {
    setIsLoading(true);
  };

  return (
    <div className='min-h-screen bg-zinc-50 flex items-center justify-center p-8'>
      <div className='w-full max-w-md'>
        <div className='flex items-center justify-center mb-8'>
          <img src={dashLogo} alt='Hughes Digital Signage' className='w-full' />
        </div>

        <div className='rounded-lg p-0'>
          <h1 className='text-xl font-semibold text-zinc-900 mb-2'>Forgot your password?</h1>
          <p className='text-sm text-zinc-500 mb-6'>Enter your email and we'll send you reset instructions.</p>

          <form onSubmit={handleSubmit} action={actionUrl} method='post' className='space-y-5'>
            <input type='hidden' name='authenticity_token' value={csrfToken} />
            <input type='hidden' name='_method' value='post' />

            <div className='space-y-1.5'>
              <Label htmlFor='email' className='text-sm font-medium text-zinc-700'>Email address</Label>
              <Input
                id='email'
                name='user[email]'
                type='email'
                placeholder='you@example.com'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className={`h-10 bg-[#ededef] shadow-none focus-visible:ring-3 focus-visible:ring-zinc-300 focus-visible:border focus-visible:border-ring${error ? ' border-red-500' : ''}`}
              />
              {error && <p className='text-sm text-red-600'>{error}</p>}
            </div>

            <Button
              type='submit'
              className='w-full h-10 bg-blue-700 hover:bg-blue-800 transition-colors'
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <div className='w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2' />
                  Sending...
                </>
              ) : (
                'Send reset instructions'
              )}
            </Button>
          </form>
        </div>

        <div className='mt-6 text-center'>
          <p className='text-sm text-zinc-600'>
            Remember your password?{' '}
            <a href='/users/sign_in' className='text-blue-600 hover:text-blue-700 transition-colors'>
              Sign in
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default MssForgotPassword;
